module.exports = __webpack_public_path__ + "static/media/nestable_icon.c275e518.svg";